frappe.provide("erpnext.e_commerce.shopping_cart");
var shopping_cart = erpnext.e_commerce.shopping_cart;

$.extend(shopping_cart, {
	show_cart_navbar: function () {
		frappe.call({
			method: "erpnext.e_commerce.doctype.e_commerce_settings.e_commerce_settings.is_cart_enabled",
			callback: function (r) {
				$(".shopping-cart").toggleClass("hidden", r.message ? false : true);
				if (r.message) {
					shopping_cart.render();
				}
			}
		});
	},

	render: function () {
		if (frappe.session.user == "Guest") return;
		const cached = localStorage.getItem("vef_cart");
		if (cached && cached.length && window.location.pathname !== "/cart") {
			const data = JSON.parse(cached);
			$(".cart-items").html(data.items);
			$(".cart-tax-items").html(data.total);
			$(".payment-summary").html(data.taxes_and_totals);
			shopping_cart.set_cart_count();
		}

		frappe.call({
			method: "vef.overrides.cart.get_cart_html",
			callback: function (r) {
				if (r.message) {
					$(".cart-items").html(r.message.items);
					$(".cart-tax-items").html(r.message.total);
					$(".payment-summary").html(r.message.taxes_and_totals);
					shopping_cart.set_cart_count();
					localStorage.setItem("vef_cart_count", frappe.get_cookie("cart_count") || 0);
					localStorage.setItem("vef_cart_items_qty", JSON.stringify(r.message.items_qty || {}));
					if (window.location.pathname === "/cart") {
						$(".cart-icon").hide();
					}
					localStorage.setItem("vef_cart", JSON.stringify(r.message));
				}
			}
		});
	},

	shopping_cart_update: function ({ item_code, qty, cart_dropdown, additional_notes }) {
		const itemsQty = JSON.parse(localStorage.getItem("vef_cart_items_qty") || "{}");
		const oldQty = itemsQty[item_code] || 0;
		const currentTotal = parseInt(localStorage.getItem("vef_cart_count") || 0);
		const optimisticTotal = currentTotal + (qty - oldQty);
		localStorage.setItem("vef_cart_count", optimisticTotal);
		localStorage.setItem("vef_cart_items_qty", JSON.stringify({ ...itemsQty, [item_code]: qty }));
		shopping_cart.set_cart_count();

		shopping_cart.update_cart({
			item_code,
			qty,
			additional_notes,
			with_items: 1,
			btn: this,
			callback: function (r) {
				if (!r.exc) {
					$(".cart-items").html(r.message.items);
					$(".cart-tax-items").html(r.message.total);
					$(".payment-summary").html(r.message.taxes_and_totals);
					shopping_cart.set_cart_count();
					localStorage.setItem("vef_cart_count", frappe.get_cookie("cart_count") || 0);
					localStorage.setItem("vef_cart_items_qty", JSON.stringify(r.message.items_qty || {}));
					localStorage.setItem("vef_cart", JSON.stringify(r.message));

					if (cart_dropdown != true) {
						$(".cart-icon").hide();
					}
				}
			},
		});
	},
});

	shopping_cart.set_cart_count = function(animate=false) {
		$(".intermediate-empty-cart").remove();

		var cart_count = frappe.get_cookie("cart_count");
		if(frappe.session.user==="Guest") {
			cart_count = 0;
		}

		if(cart_count) {
			$(".shopping-cart").toggleClass('hidden', false);
		}

		var $cart = $('.cart-icon');
		var $badge = $cart.find("#cart-count");

		if(parseInt(cart_count) === 0 || cart_count === undefined) {
			$cart.css("display", "none");
			$(".cart-tax-items").hide();
			$(".btn-place-order").hide();
			$(".cart-payment-addresses").hide();

			let intermediate_empty_cart_msg = `
				<div class="text-center w-100 intermediate-empty-cart mt-4 mb-4 text-muted">
					${ __("Cart is Empty") }
				</div>
			`;
			$(".cart-table").after(intermediate_empty_cart_msg);
		}
		else {
			if (window.location.pathname !== "/cart") {
				$cart.css("display", "inline");
				$("#cart-count").text(cart_count);
			}
		}

		if(cart_count) {
			if (!$badge.length) {
				$cart.find("a").append('<span class="badge badge-primary shopping-badge" id="cart-count"></span>');
				$badge = $cart.find("#cart-count");
			}
			$badge.html(cart_count);

			if (animate) {
				$cart.addClass("cart-animate");
				setTimeout(() => {
					$cart.removeClass("cart-animate");
				}, 500);
			}
		} else {
			$badge.remove();
		}
	}

window.addEventListener("pageshow", function (e) {
	if (e.persisted && window.location.pathname !== "/cart") {
		const count = parseInt(localStorage.getItem("vef_cart_count") || 0);
		if (count > 0) {
			const $cartIcon = $(".cart-icon");
			let $badge = $cartIcon.find("#cart-count");
			if (!$badge.length) {
				$cartIcon.find("a").append('<span class="badge badge-primary shopping-badge" id="cart-count"></span>');
				$badge = $cartIcon.find("#cart-count");
			}
			$badge.html(count);
			$cartIcon.css("display", "inline");
		}
		location.reload();
	}
});

frappe.ready(function () {
	if (window.location.pathname !== "/cart") return;

	const cart_render = frappe.utils.throttle(shopping_cart.render, 250);

	shopping_cart.bind_place_order = function () {
		$(".cart-container").on("click", ".btn-place-order", function () {
			shopping_cart.place_order(this);
		});
	};

	document.addEventListener("visibilitychange", function () {
		if (document.visibilityState === "visible" && window.location.pathname === "/cart") {
			cart_render();
		}
	});

	window.addEventListener("pageshow", function (e) {
		if (e.persisted && window.location.pathname === "/cart") {
			cart_render();
		}
	});

	window.addEventListener("focus", function () {
		if (window.location.pathname === "/cart") {
			cart_render();
		}
	});
});
